const tooltipStyles = `
box-shadow: rgb(100, 100, 100) 3px 3px 6px;
color: #fff;
background-color: #000;
border-radius: 4px;
padding: 6px;
position: absolute;
width: max-content;
max-width: 300px;
font-style: normal;
font-size: .8rem;
z-index: 50;`;

const caretStyles = `position: absolute;`;


export default function tooltip(element, options) {
    let div;
    let caret;
    let title;
    let showing = false;

    options = options || { position: "bottom" };

    function mouseOver(event) {
        if (showing) return;
        showing = true;

        title = element.getAttribute('title');
        element.removeAttribute('title');
        element.style.position = "relative";

        div = document.createElement('div');
        div.innerHTML = title;
        div.style = tooltipStyles;

        caret = document.createElement('div');
        caret.style = caretStyles;
        div.appendChild(caret);

        element.appendChild(div);

        const iconRect = element.getBoundingClientRect();
        const tooltipRect = div.getBoundingClientRect();

        // Center horizontally relative to icon
        let left = (iconRect.width / 2) - (tooltipRect.width / 2);
        // Position 10px below icon
        let top = iconRect.height + 10;

        // default to bottom
        if (options.position === "top") {
            caret.style.borderLeft = "8px solid transparent";
            caret.style.borderRight = "8px solid transparent";
            caret.style.borderTop = "8px solid #000";

            caret.style.bottom = "-8px";
            caret.style.left = "50%";
            caret.style.transform = "translateX(-50%)";

            caret.style.filter = "drop-shadow(3px 3px 6px rgba(100, 100, 100))";

            left = (iconRect.width / 2) - (tooltipRect.width / 2);
            top = -(tooltipRect.height + 10);
        } else if (options.position === "left") {
            caret.style.borderTop = "8px solid transparent";
            caret.style.borderBottom = "8px solid transparent";
            caret.style.borderLeft = "8px solid #000";

            caret.style.right = "-8px";
            caret.style.top = "50%";
            caret.style.transform = "translateY(-50%)";

            caret.style.filter = "drop-shadow(3px 3px 6px rgba(100, 100, 100))";

            left = -(tooltipRect.width + 10);
            top = (iconRect.height / 2) - (tooltipRect.height / 2);
        } else if (options.position === "right") {
            caret.style.borderTop = "8px solid transparent";
            caret.style.borderBottom = "8px solid transparent";
            caret.style.borderRight = "8px solid #000";

            caret.style.left = "-8px";
            caret.style.top = "50%";
            caret.style.transform = "translateY(-50%)";

            left = iconRect.width + 10;
            top = (iconRect.height / 2) - (tooltipRect.height / 2);
        } else {
            caret.style.borderLeft = "8px solid transparent";
            caret.style.borderRight = "8px solid transparent";
            caret.style.borderBottom = "8px solid #000";

            caret.style.bottom = "-8px";
            caret.style.left = "50%";
            caret.style.transform = "translateX(-50%)";

            left = (iconRect.width / 2) - (tooltipRect.width / 2);
            top = iconRect.height + 10;
        }

        div.style.left = `${left}px`;
        div.style.top = `${top}px`;
    }

    function mouseLeave() {
        if (!showing) return;

        div.parentNode.removeChild(div);
        element.setAttribute('title', title);

        showing = false;
    }

    element.addEventListener('mouseover', mouseOver);
    element.addEventListener('mouseleave', mouseLeave);

    return {
        destroy() {
            element.removeEventListener('mouseover', mouseOver);
            element.removeEventListener('mouseleave', mouseLeave);
        }
    }
}